// Localização: frontend/src/components/Prontuario/Profissional/RH/BancoHorasSection.jsx (versão 1.0.0)
// Seção de Banco de Horas do prontuário do profissional

import React, { useState, useEffect } from 'react';
import { Clock, TrendingUp, TrendingDown } from 'lucide-react';
import { getBancoHoras } from '../../../../api/api';
import { formatDate } from '../../../../utils/formatters';

const BancoHorasSection = ({ profissionalId, onRefresh }) => {
    const [bancoHoras, setBancoHoras] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBancoHoras();
    }, [profissionalId]);

    const fetchBancoHoras = async () => {
        try {
            setLoading(true);
            const response = await getBancoHoras(profissionalId);
            if (response.data.success) {
                setBancoHoras(response.data.data || []);
            }
        } catch (error) {
            console.error('Erro ao buscar banco de horas:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-8">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Banco de Horas</h3>

            {bancoHoras.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                    <Clock className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                    <p>Nenhum registro de banco de horas.</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {bancoHoras.map((registro) => {
                        const saldo = parseFloat(registro.saldo_horas || 0);
                        const isPositivo = saldo >= 0;
                        return (
                            <div
                                key={registro.id}
                                className={`border rounded-lg p-4 ${
                                    isPositivo ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'
                                }`}
                            >
                                <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                        <div className="flex items-center space-x-2 mb-2">
                                            <Clock className="h-5 w-5 text-gray-600" />
                                            <span className="font-semibold text-gray-900">
                                                {new Date(registro.data_referencia).toLocaleDateString('pt-BR', {
                                                    month: 'long',
                                                    year: 'numeric'
                                                })}
                                            </span>
                                        </div>
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                                            <div>
                                                <span className="font-medium">Horas Extras:</span>{' '}
                                                <span className="text-green-700">+{parseFloat(registro.horas_extras || 0).toFixed(2)}h</span>
                                            </div>
                                            <div>
                                                <span className="font-medium">Horas Faltantes:</span>{' '}
                                                <span className="text-red-700">-{parseFloat(registro.horas_faltantes || 0).toFixed(2)}h</span>
                                            </div>
                                            <div>
                                                <span className="font-medium">Saldo:</span>{' '}
                                                <span className={`font-bold ${isPositivo ? 'text-green-700' : 'text-red-700'}`}>
                                                    {saldo.toFixed(2)}h
                                                </span>
                                            </div>
                                            {registro.tipo_compensacao && (
                                                <div>
                                                    <span className="font-medium">Compensação:</span>{' '}
                                                    {registro.tipo_compensacao}
                                                </div>
                                            )}
                                        </div>
                                        {registro.observacoes && (
                                            <div className="mt-2 text-sm text-gray-600">
                                                <span className="font-medium">Observações:</span> {registro.observacoes}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default BancoHorasSection;

